export default "__VITE_ASSET__DOouzLjW__"